import {
    SwitchRenderer,
    RangeRenderer,
    DropdownRenderer,
    SimpleNumberRenderer,
    SwitchWithSelectRenderer,
    NestedMatch,
    TermRenderer,
    AutocompleteRenderer,
    SwitchWithAutocompleteRenderer,
    SwitchWithSelectAndTagsRenderer,
    NumberOrSelectRenderer,
    PercentRange,
    SwitchWIthYearSelectRenderer,
    SwitchWithAdditionalSwitchQuestionAndSelectRenderer
} from "scenes/cohort-filters/filter-builder/filter-components/search-rule-widgets";
import { TagsRenderer } from "scenes/cohort-filters/filter-builder/filter-components/search-rule-widgets/TagsRenderer";

import { WidgetType } from "./widgetTypes";

export const inputRendererMap = {
    [WidgetType.DROPDOWN]: DropdownRenderer,
    [WidgetType.AUTOCOMPLETE]: AutocompleteRenderer,
    [WidgetType.SIMPLE_NUMBER]: SimpleNumberRenderer,
    [WidgetType.SWITCH]: SwitchRenderer,
    [WidgetType.SWITCH_WITH_SELECT]: SwitchWithSelectRenderer,
    [WidgetType.SWITCH_WITH_SELECT_AND_TAGS]: SwitchWithSelectAndTagsRenderer,
    [WidgetType.SWITCH_WITH_AUTOCOMPLETE]: SwitchWithAutocompleteRenderer,
    [WidgetType.RANGE_FILTER]: RangeRenderer,
    [WidgetType.NESTED]: NestedMatch,
    [WidgetType.TERM]: TermRenderer,
    [WidgetType.TAGS]: TagsRenderer,
    [WidgetType.NUMBER_OR_SELECT]: NumberOrSelectRenderer,
    [WidgetType.NUMBER_RANGE]: PercentRange,
    [WidgetType.SWITCH_WITH_YEAR_SELECTOR]: SwitchWIthYearSelectRenderer,
    [WidgetType.SWITCH_WITH_ADDITIONAL_SWITCH_QUESTION_AND_SELECT]: SwitchWithAdditionalSwitchQuestionAndSelectRenderer
};
